import { render, staticRenderFns } from "./pause-34.vue?vue&type=template&id=5a1f5458&scoped=true"
import script from "./pause-34.vue?vue&type=script&lang=js"
export * from "./pause-34.vue?vue&type=script&lang=js"
import style0 from "./pause-34.vue?vue&type=style&index=0&id=5a1f5458&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1f5458",
  null
  
)

export default component.exports